<template>
    <v-col cols="12">
        <v-card class="ma-2">
            <v-card-title class="title font-weight-black">
                <v-icon class="pr-3">home</v-icon> Quick-Load New Hotel
            </v-card-title>

            <v-card-text>
                <v-container>
                    <fieldset>
                        <legend>Questionnaire Information</legend>
                        <v-row>
<!--
                            <v-col cols="3"><v-label>Your Name:</v-label></v-col>
                            <v-col cols="8">Skipped for now, as we are unsure how to determine which field(s) it would go into</v-col>
-->
                            <!--
                            <v-col cols="3"><v-label>Editorial Region:</v-label></v-col>
                            <v-col cols="8">
                                <v-select
                                    v-model="regionKey"
                                    label="Region"
                                    :items="regions"
                                    autocomplete
                                ></v-select>
                            </v-col>
                            -->

                            <v-col cols="3"><v-label>Address 1:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="address1" label="Address 1" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>Address 2:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="address2" label="Address 2" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>City*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.city">{{ validation.messages.city }}</div>
                                <v-text-field v-model="city" label="City" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Post Code:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="postCode" label="Post Code" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>Postal Address:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="postalAddress" label="Postal Address" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>Website*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.website">{{ validation.messages.website }}</div>
                                <v-text-field v-model="website" label="Website" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Main Contact Name*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.keyContact">{{ validation.messages.keyContact }}</div>
                                <v-text-field v-model="keyContact" label="Main Contact Name" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Marketing Contact Name:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="marketingName" label="Marketing Contact Name" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>Marketing Email:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="marketingEmail" label="Marketing Email" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>Owner*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.owner">{{ validation.messages.owner }}</div>
                                <v-text-field v-model="owner" label="Owner Name" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>GPS Location (Latitude, Longitude) *:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.googleMapPosition">{{ validation.messages.googleMapPosition }}</div>
                                <v-text-field v-model="googleMapPosition" label="GPS" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Detailed directions*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.detailedDirections">{{ validation.messages.detailedDirections }}</div>
                                <v-textarea v-model="detailedDirections" dense></v-textarea>
                            </v-col>

                            <v-col cols="3"><v-label>When Did Property First Open?</v-label></v-col>
                            <v-col cols="8"><v-textarea v-model="dateOpened" dense></v-textarea></v-col>

                            <v-col cols="3"><v-label>Type of Property*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.propertyType">{{ validation.messages.propertyType }}</div>
                                <v-select
                                        v-model="propertyType"
                                        label="Property Type"
                                        :items="propertyTypes"
                                        autocomplete
                                        outlined dense
                                ></v-select>
                            </v-col>

                            <v-col cols="3"><v-label>Total No. Rooms:</v-label></v-col>
                            <v-col cols="8"><v-text-field v-model="totalNumRooms" label="Total No. Rooms" outlined dense></v-text-field></v-col>

                            <v-col cols="3"><v-label>Rates:</v-label></v-col>
                            <v-col cols="8">Room types should be loaded later</v-col>

                            <v-col cols="3"><v-label>Channel Manager:</v-label></v-col>
                            <v-col cols="8">
                                <ies-input-channel-manager-names :field="channelManagerField"></ies-input-channel-manager-names>
                            </v-col>

                            <v-col cols="3"><v-label>Currency*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.currencyKey">{{ validation.messages.currencyKey }}</div>
                                <v-select
                                        v-model="currencyKey"
                                        label="Currency"
                                        :items="currencies"
                                        autocomplete
                                        outlined dense
                                ></v-select>
                            </v-col>


                            <v-col cols="3"><v-label>Default Rate Basis*:</v-label></v-col>
                            <v-col cols="8">
                                <v-select
                                        v-model="defaultRateBasis"
                                        label="Default Rate Basis"
                                        :items="rateBasisOptions"
                                        autocomplete
                                        outlined dense
                                ></v-select>
                            </v-col>

                            <v-col cols="3"><v-label>Optional Extras:</v-label></v-col>
                            <v-col cols="8"><v-textarea v-model="rateOptionalExtras" dense></v-textarea></v-col>

                            <v-col cols="3"><v-label>Accepted Credit Cards*:</v-label></v-col>
                            <v-col cols="8">
                                <v-layout row wrap>
                                    <v-col cols="3"><label>Mastercard <img src="/images/logos/mastercard.svg" class="cc-logo" alt="MasterCard"></label></v-col>
                                    <v-col cols="9"><v-checkbox hide-details v-model="acceptsMastercard"></v-checkbox></v-col>
                                    <v-col cols="3"><label>Visa <img src="/images/logos/visa.png" class="cc-logo" alt="Visa"></label></v-col>
                                    <v-col cols="9"><v-checkbox hide-details v-model="acceptsVisa"></v-checkbox></v-col>
                                    <v-col cols="3"><label>Amex <img src="/images/logos/american-express.svg" class="cc-logo" alt="American Express"></label></v-col>
                                    <v-col cols="9"><v-checkbox hide-details v-model="acceptsAmex"></v-checkbox></v-col>
                                    <!--
                                    <v-col cols="2"><label>Diners <img src="/images/logos/diners.svg" class="cc-logo" alt="Diners Club" style="max-height: 2rem; margin-bottom: -10px;"></label></v-col>
                                    <v-col cols="10"><v-checkbox hide-details v-model="acceptsDiners"></v-checkbox></v-col>
                                    <v-col cols="2"><label>Maestro <img src="/images/logos/maestro.png" class="cc-logo" alt="Maestro"></label></v-col>
                                    <v-col cols="10"><v-checkbox hide-details v-model="acceptsMaestro"></v-checkbox></v-col>
                                    -->
                                </v-layout>
                                <div>Rate Types and Policies should be loaded later</div>
                            </v-col>

                            <v-col cols="3"><v-label>Nearest Airport 1 (km)*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.airportName1">{{ validation.messages.airportName1 }}</div>
                                <v-text-field v-model="airportName1" label="Name" outlined dense></v-text-field>
                                <div class="error-message" v-if="validation.messages.airportDistance1">{{ validation.messages.airportDistance1 }}</div>
                                <v-text-field v-model="airportDistance1" label="Distance" outlined dense></v-text-field>
                                <div class="error-message" v-if="validation.messages.airportCode1">{{ validation.messages.airportCode1 }}</div>
                                <v-text-field v-model="airportCode1" label="Code" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Nearest Airport 2 (km)*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.airportName2">{{ validation.messages.airportName2 }}</div>
                                <v-text-field v-model="airportName2" label="Name" outlined dense></v-text-field>
                                <div class="error-message" v-if="validation.messages.airportDistance2">{{ validation.messages.airportDistance2 }}</div>
                                <v-text-field v-model="airportDistance2" label="Distance" outlined dense></v-text-field>
                                <div class="error-message" v-if="validation.messages.airportCode2">{{ validation.messages.airportCode2 }}</div>
                                <v-text-field v-model="airportCode2" label="Code" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Nearest Restaurant (km)*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.restaurantDistance">{{ validation.messages.restaurantDistance }}</div>
                                <v-text-field v-model="restaurantDistance" label="Distance" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Nearest Shop (km)*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.shopsDistance">{{ validation.messages.shopsDistance }}</div>
                                <v-text-field v-model="shopsDistance" label="Distance" outlined dense></v-text-field>
                            </v-col>

                            <v-col cols="3"><v-label>Display Status*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.displayStatus">{{ validation.messages.displayStatus }}</div>
                                <v-select 
                                        v-model="displayStatus"
                                        label="Display Status"
                                        :items="displayStatuses"
                                        autocomplete
                                        outlined dense
                                ></v-select>
                            </v-col>

                            <v-col cols="3"><v-label>Travel Operator*:</v-label></v-col>
                            <v-col cols="8">
                                <div class="error-message" v-if="validation.messages.travelOperator">{{ validation.messages.travelOperator }}</div>
                                <v-select 
                                        v-model="travelOperator"
                                        label="Travel Operator"
                                        :items="travelOperators"
                                        autocomplete
                                        outlined dense
                                ></v-select>
                            </v-col>


                            <v-col cols="12"><v-btn v-on:click="save()" class="lime">Update Hotel</v-btn></v-col>
                        </v-row>
                    </fieldset>
                </v-container>
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    /**
     * Display new hotels form
     */
    export default {
        props:['hotel'],

        components: {
            'ies-input-channel-manager-names': require('../inputs/ChannelManagerNames.vue').default,
        },

        data: function() {
            return {
                regions: [],
                travelOperators: [],
                displayStatuses: [{value: 0, text: "Offline"}, {value: 1, text: "Online"}, {value: 2, text: "Preview"}],
                hotelKey: 0,
                hotelName: "",
                propertyTypes: [{value: "hotel", text: "Hotel/B&B"}, {value: "rental", text: "Rental"}, {value: "tmt", text: "Tailor Made Tour"}],
                propertyType: "hotel",
                dateOpened: "",
                currency: 0,
                currencyKey: 0,
                currencies: [],
                regionKey: null,
                displayStatus: 2,
                restaurantDistance: "",
                shopsDistance: "",
                airportName1: "",
                airportDistance1: "",
                airportCode1: "",
                airportName2: "",
                airportDistance2: "",
                airportCode2: "",
                travelOperator: 0,

                address1: "",
                address2: "",
                city: "",
                postCode: "",
                postalAddress: "",
                detailedDirections: "",
                googleMapPosition: "",
                website: "",
                owner: "",
                keyContact: "",
                marketingName: "",
                marketingEmail: "",

                totalNumRooms: "",
                channelManagerField: { fieldName: 'globalDistributionSystem', value: "" },
                defaultRateBasis: 1,
                rateBasisOptions: [{value:0, text:"Please choose..."}, {value:1, text:"Room"}, {value:2, text:"Apartment"}, {value:3, text:"Cottage"}, {value:4, text:"Villa"},
                                   {value:5, text:"House"}, {value:6, text:"Boat"}, {value:7, text:"Unit"}, {value:8, text:"Whole&nbsp;House"}],
                rateOptionalExtras: "",

                acceptsMastercard: false,
                acceptsVisa: false,
                acceptsAmex: false,
                acceptsDiners: false,
                acceptsMaestro: false,
                validation: {isValid: true, messages: {}}
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            //this.getRegions();
            this.getTravelOperators();
            this.getCurrencies();
            var hotel = JSON.parse(this.hotel);
            console.log("this hotel", hotel);
            this.hotelKey = hotel.hotel_key;

            /*
            this.$root.$on('Image Browser: select hotel', function(payload){
                console.log("i Have heard ", payload);
                self.hotelKey = payload.hotelKey;
            });
            */
        },

        methods: {
            getTravelOperators: function(){
                var self = this;
                this.travelOperators.push({value: 0, text: "New Account"});
                axios.get('/api/travel-operators?x=y')
                .then((response)=>{
                    if (response.data.success){
                        console.log(response.data);
                        response.data.travelOperators.forEach(function(account){
                            self.travelOperators.push({ value: account.user_key, text: account.username });
                        });
                    }
                    // If it failed then simply tell them so
                    else {
                        alert("A problem occurred and the hotel could not be updated");
                    }
                });
            },

            getCurrencies: function(){
                var self = this;
                this.currencies.push({value: 0, text: "Use Region Default"});
                axios.get('/api/selectable-currencies')
                .then((response)=>{
                    if (response.data.success){
                        console.log(response.data);
                        response.data.currencies.forEach(function(currency){
                            self.currencies.push({ value: currency.currency_key, text: currency.currency_name });
                        });
                    } else {
                    // If it failed then simply tell them so
                        alert("A problem occurred and the currencies could not be downloaded");
                    }
                });
            },

            save: function(){
                axios.post('/api/hotels/' + this.hotelKey + '/onboard', {
                    hotelKey: this.hotelKey, 
                    propertyType: this.propertyType,
                    dateOpened: this.dateOpened,
                    regionKey: this.regionKey, 
                    currencyKey: this.currencyKey,
                    displayStatus: this.displayStatus, 
                    travelOperator: this.travelOperator,

                    address1: this.address1,
                    address2: this.address2,
                    city: this.city,
                    postCode: this.postCode,
                    postalAddress: this.postalAddress,
                    detailedDirections: this.detailedDirections,
                    googleMapPosition: this.googleMapPosition,
                    website: this.website,
                    owner: this.owner,
                    keyContact: this.keyContact,
                    marketingName: this.marketingName,
                    marketingEmail: this.marketingEmail,

                    restaurantDistance: this.restaurantDistance,
                    shopsDistance: this.shopsDistance,
                    airportName1: this.airportName1,
                    airportDistance1: this.airportDistance1,
                    airportCode1: this.airportCode1,
                    airportName2: this.airportName2,
                    airportDistance2: this.airportDistance2,
                    airportCode2: this.airportCode2,

                    totalNumRooms: this.totalNumRooms,
                    channelManager: this.channelManagerField.value,
                    defaultRateBasis: this.defaultRateBasis,
                    rateOptionalExtras: this.rateOptionalExtras,

                    acceptsMastercard: this.acceptsMastercard,
                    acceptsVisa: this.acceptsVisa,
                    acceptsAmex: this.acceptsAmex,
                    acceptsDiners: this.acceptsDiners,
                    acceptsMaestro: this.acceptsMaestro

                })
                .then((response)=>{
                    console.log(response.data);
                    // If it was successful then reload the voucher details so it is 
                    // displayed up to date on the page
                    this.validation = response.data.validation;
                    console.log("validation",this.validation);
                    if (response.data.success){
                        var hotel = response.data.hotel;
                        window.location.href="/hotel/" + hotel.hotel_key + '/dashboard';
                    }
                    // If it failed then simply tell them so
                    else {
                        console.log("I have failed");
                        alert("Please correct the validation issues");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    alert("Error during save");
                })
                ;
            },

/*
            getRegions:function(){
                axios.get('/api/selectable-regions')
                .then(function(response){
                    var regions = [];
                    response.data.regions.forEach(function(record){
                        regions.push({ text: record.region_name, value: record.region_key });
                    });
                    this.regions = regions;
                }.bind(this));
            },
*/
        },

        computed: {}
    }
</script>

<style>
.v-input--selection-controls {
    margin-top: 0;
    padding-top: 0;
}

.accepted-credit-cards .col .v-input--selection-controls {
    margin-top: 0;
}

.cc-logo {
    border: none;
    max-height: 1rem;
}

.error-message {
    color: red;
}
</style>
